import { cn } from "../../lib/utils.js";

/**
 * Globo rojo con un contador: las alertas sin leer del nav, los dispositivos
 * pendientes del rail de /admin.
 *
 * Vive acá porque el MISMO número se dibuja en varios sitios a la vez — el
 * padre (pestaña o trigger del desplegable) y el destino que lo apaga. Cuatro
 * copias del markup era justo como el globo terminaba puesto en el padre y no
 * en el hijo.
 *
 * `count <= 0` no pinta nada: quien lo use no necesita envolverlo en un
 * condicional. `label` es lo que se lee en voz alta ("3 alertas sin leer");
 * sin él un lector de pantalla anuncia un "3" pelado pegado al título.
 *
 * El `role="img"` va con el rótulo y no sin él: un `aria-label` sobre un `span`
 * pelado es un nombre de autor sobre el rol `generic`, que ARIA 1.2 NO permite
 * —Chromium y Gecko lo leen igual, pero WebKit lo ignora, y en iPhone la app
 * corre como PWA sobre WebKit, así que ahí el globo quedaba mudo y ningún test
 * lo delataba (jsdom sí lo honra)—. Con `role="img"` el nombre es válido y de
 * paso el "3" del contenido deja de competir con la frase completa. Sin rótulo
 * no se pone rol: un `img` sin nombre accesible es peor que un span.
 */
export function CountBadge({ count, label, className }) {
  if (!(count > 0)) return null;

  return (
    <span
      className={cn(
        // `text-white` y no `text-text-primary`: el globo es un relleno de
        // marca, y sobre un relleno el par correcto es el blanco en los DOS
        // temas. `text-primary` se vuelve tinta casi negra en claro, que sobre
        // el rojo del globo da 3.1:1 — el número dejaría de leerse.
        "flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-full bg-danger px-1 text-2xs font-bold text-white",
        className,
      )}
      role={label ? "img" : undefined}
      aria-label={label ? `${count} ${label}` : undefined}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
